import { Avatar, AvatarIcon, Divider, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, Navbar, NavbarBrand, NavbarContent, NavbarItem, User } from "@nextui-org/react";
import { Auth } from "firebase/auth";
import { useAuth, useUser } from "reactfire";
import { UsageMeter } from "./usageMeter";
import { Link, useNavigate } from "react-router-dom";
import { MdDocumentScanner, MdEditDocument } from "react-icons/md";

const Header = () => {


    const auth = useAuth();
    const user = useUser();
    const navigate = useNavigate();

    const signOut = (auth: Auth) => {
        auth.signOut().then(() => navigate('/login'));
    };

    return (
        <Navbar isBordered maxWidth="full">

            <NavbarBrand className="mx-16">
                <img src="/logo.png" height={30} width={30} />
                <p className="font-bold text-2xl inter-bold px-2">DoxPro</p>
            </NavbarBrand>
            {user.data ? (
                <NavbarContent justify="start" className="flex py-4">
                    <NavbarItem>
                        <Link color="foreground" to="/extractors">
                            DoxEx
                        </Link>
                    </NavbarItem>
                    <Divider orientation="vertical" />
                    <NavbarItem >
                        <Link color="foreground" to="/generators" >
                            DoxGen
                        </Link>
                    </NavbarItem>
                    <Divider orientation="vertical" />
                    <NavbarItem >
                        <Link color="foreground" to="/comparators" >
                            DoxComp
                        </Link>
                    </NavbarItem>
                    <Divider orientation="vertical" />
                    <NavbarItem >
                        <Link color="foreground" to="/kbases" >
                            DoxBase
                        </Link>
                    </NavbarItem>
                    <Divider orientation="vertical" />
                    <NavbarItem >
                        <Link color="foreground" to="/jobmanager" >
                            DoxBench
                        </Link>
                    </NavbarItem>
                </NavbarContent>
            ) : <></>}
            <NavbarContent justify="end" className="mx-16">
                {user.data && (
                    <NavbarItem>
                        {user && <UsageMeter />}
                    </NavbarItem>
                )}
                {/* Avatar for user */}
                <NavbarItem className="hidden lg:flex">
                    {user.data ? (
                        <Dropdown>
                            <DropdownTrigger>
                                <User
                                    name={user.data.displayName || 'Unknown'}
                                    description={user.data.email || 'Unknown'}
                                    avatarProps={{
                                        src: user.data.photoURL || 'Unknown',
                                    }}
                                    className="cursor-pointer"
                                />
                            </DropdownTrigger>
                            <DropdownMenu aria-label="User menu">
                                <DropdownItem key="settings" onPress={() => navigate('/settings')}>
                                    Settings
                                </DropdownItem>
                                <DropdownItem key="signout" onPress={() => signOut(auth)} className="text-danger" color="danger">
                                    Sign Out
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    ) : (
                        <>
                            <User
                                name="Sign In"
                                avatarProps={<Avatar
                                    icon={<AvatarIcon />}
                                    classNames={{
                                        base: "bg-gradient-to-br from-[#FFB457] to-[#FF705B]",
                                        icon: "text-black/80",
                                    }}
                                />}
                                onClick={() => navigate(`/login`)}
                            />
                        </>
                    )}
                </NavbarItem>
            </NavbarContent>
        </Navbar>
    );
}

export default Header;